'use strict'

Object.defineProperty(exports, '__esModule', {
  value: true
})

var _templateObject = _taggedTemplateLiteral(
  ['line-height: 1.25;'],
  ['line-height: 1.25;']
)

var _Text = require('./Text')

var _Text2 = _interopRequireDefault(_Text)

var _theme = require('./theme')

var _theme2 = _interopRequireDefault(_theme)

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj }
}

function _taggedTemplateLiteral(strings, raw) {
  return Object.freeze(
    Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })
  )
}

var Heading = _Text2.default.withComponent('h2').extend(_templateObject)

Heading.displayName = 'Heading'

Heading.defaultProps = {
  theme: _theme2.default,
  regular: true,
  f: 5,
  m: 0
}

Heading.h1 = Heading.withComponent('h1')
Heading.h1.defaultProps = {
  bold: true,
  f: 6,
  m: 0
}

Heading.h2 = Heading.withComponent('h2')
Heading.h2.defaultProps = {
  bold: true,
  f: 5,
  m: 0
}

Heading.h3 = Heading.withComponent('h3')
Heading.h3.defaultProps = {
  bold: true,
  f: 4,
  m: 0
}

Heading.h4 = Heading.withComponent('h4')
Heading.h4.defaultProps = {
  regular: true,
  f: 3,
  m: 0
}

Heading.h5 = Heading.withComponent('h5')
Heading.h5.defaultProps = {
  bold: true,
  f: 2,
  m: 0
}

Heading.h6 = Heading.withComponent('h6')
Heading.h6.defaultProps = {
  bold: true,
  caps: true,
  f: 0,
  m: 0
}

exports.default = Heading



//////////////////
// WEBPACK FOOTER
// ./~/@hackclub/design-system/dist/Heading.js
// module id = 121
// module chunks = 168707334958949